import React, { useEffect } from 'react';
import './Toast.css';

function Toast({ message, type, onClose, duration = 15000 }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className={`toast-notification ${type}`}>
      <div className="toast-icon">
        {type === 'success' ? '✅' : '❌'}
      </div>
      <div className="toast-content">
        <div className="toast-title">
          {type === 'success' ? 'Success!' : 'Error!'}
        </div>
        <div className="toast-message">{message}</div>
      </div>
      <button className="toast-close" onClick={onClose}>
        ×
      </button>
    </div>
  );
}

export default Toast;